import * as svg from "../../../assets/message-icon.svg";

import {iconBuilder} from "./iconBuilder";

const MessageIcon = iconBuilder(svg, "MessageIcon", "0 0 16 16");

export default MessageIcon;
